import { KeyValue } from '@/main/models/common';
import { YearTypes, YearActionTypes } from './yearTypes';
import { VehicleYearRequest } from '@/main/models/request';

export function getYears(keyReducer: string = 'default'): YearActionTypes {
  return {
    type: YearTypes.GET_YEARS,
    payload: { keyReducer }
  };
}

export function getYearByManufacturerAndModel(
  request: VehicleYearRequest,
  keyReducer: string = 'default'
): YearActionTypes {
  return {
    type: YearTypes.GET_YEARS_BY_MANUFACTURER_AND_MODEL,
    payload: { request, keyReducer }
  };
}

export function saveYears(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null,
  keyReducer: string = 'default'
): YearActionTypes {
  return {
    type: YearTypes.SAVE_YEARS,
    payload: { data, isError, errorMessages, keyReducer }
  };
}

export function resetReducerYears(
  keyReducer: string = 'default'
): YearActionTypes {
  return {
    type: YearTypes.RESET_REDUCER_YEARS,
    payload: { keyReducer }
  };
}

